import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { DocumentDataStore } from '../document-data/document-data.store';
import { Invoice } from './invoice.model';
import { getSchedules, IState, selectFeature } from './invoice-data.reducer';
import { Schedule } from '../document-data/sub-models/schedule.model';
import { Observable } from 'rxjs';
import { List } from 'immutable';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { Document } from '../document-data/document.model';

@Injectable()
export class InvoiceDataStore extends DocumentDataStore<IState, Invoice> {
  schedules$: Observable<List<Schedule>> = this.store.select(getSchedules());

  constructor(store: Store<any>) {
    super(store, selectFeature);
  }

  getSortedList(listFilter: string): Observable<List<Invoice>> {
    return super.getSortedList(listFilter).pipe(
      withLatestFrom(this.schedules$),
      map(([invoices, schedules]: [List<Invoice>, List<Schedule>]) => {
        if (!invoices) {
          return null;
        }

        return invoices.map(
          (invoice: Invoice) =>
            invoice.setIn(
              [Document.KEYS.SCHEDULE],
              new Schedule(
                schedules.find(
                  (schedule: Schedule) => schedule.invoiceId === invoice.id
                )
              )
            ) as Invoice
        ) as List<Invoice>;
      })
    );
  }

  getSchedulesByInvoiceId(invoiceId: string): Observable<Schedule> {
    return this.schedules$.pipe(
      filter((x) => !!x),
      map((schedules: List<Schedule>) =>
        schedules.find((schedule: Schedule) => schedule.invoiceId === invoiceId)
      )
    );
  }
}
